import { ConstObjectValue } from "./shared";

export const OpenAIModels = {
    GPT_4: "gpt-4o",
    GPT_4_MINI: "gpt-4o-mini",
} as const;
export type OpenAIModels = ConstObjectValue<typeof OpenAIModels>;
